import { Component, Inject, Input, DOCUMENT, ChangeDetectionStrategy, OnInit } from '@angular/core';

import { PillsService } from '@shared/services';
import { PillModel    } from '@shared/models';

@Component({
  selector:      'pills-picker',
  templateUrl: './pills-picker.component.html',
  styleUrls:  ['./pills-picker.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PillsPickerComponent implements OnInit {
  public static readonly COMPONENT_NAME: string = 'PillsPickerPopup';

  search:        string = '';
  favouriteOpen: boolean = true;
  allOpen:       boolean = true;

  @Input() title:        string;
  @Input() popupPills:   PillModel[] = [];
  @Input() singleSelect: boolean = false;
  @Input() isInternal:   boolean = false;
  constructor(
    @Inject(DOCUMENT) public readonly document: Document,
    private pillsService: PillsService
  ) { }

  ngOnInit(): void {
    this.pillsService.pills.subscribe(pills => {
      if (this.pillsAddedOrRemoved(pills)) this.closePopup();
    });
  }

  private pillsAddedOrRemoved(pills: PillModel[]): boolean {
    const current = pills ?? [];
    if (current.length !== this.popupPills.length) return true;
    return current.some(pill => !this.popupPills.some(p => this.pillsService.IsEqual(p, pill)));
  }

  closePopup(): void {
    this.pillsService.closePicker();
  }

  savePills(): void {
    const [needUpdate, needRefresh] = this.pillsService.getChangeStatus(this.popupPills);
    if (needUpdate) this.pillsService.persistPills(this.popupPills, !needRefresh);
    this.closePopup();
  }

  filterEntriesBySearch(pills: PillModel[]): PillModel[] {
    if (this.search) return pills.filter(l => l.label.toLowerCase().includes(this.search.toLowerCase()));
    return pills;
  }

  togglePopupEntry(e: Event, entry: PillModel): void {
    e.preventDefault();
    e.stopPropagation();
    if (this.singleSelect) this.toggleSingleSelectCheckbox(entry);
    else this.toggleCheckbox(entry);
  }

  private toggleSingleSelectCheckbox(entry: PillModel): void {
    this.popupPills.forEach(ent => ent.active = false);
    let pill = this.popupPills.find(e => e.company_number === entry.company_number);
    pill.active = true;
  }

  private toggleCheckbox(entry: PillModel): void {
    if (this.pillsService.checkLimits(this.popupPills)) entry.active = !entry.active;
    else entry.active = false;
  }

  toggleShowEntry($event: Event, entry: PillModel): void {
    $event.preventDefault();
    $event.stopPropagation();
    entry.favourite = !entry.favourite;
  }

  get activeCompany():        PillModel   { return this.singleSelect && this.popupPills?.find(p => p.active); }
  get activePills():          PillModel[] { return this.popupPills?.filter(p => p.active);     }
  get favouritePills():       PillModel[] { return this.popupPills?.filter(p => p.favourite);  }
  get activeFavouritePills(): PillModel[] { return this.favouritePills?.filter(p => p.active); }

  get allPillsSecected():  boolean { return  this.filterEntriesBySearch(this.activePills).length === this.filterEntriesBySearch(this.popupPills).length; };
  get nonePillsSecected(): boolean { return !this.filterEntriesBySearch(this.activePills).length; }

  selectAll(  pills: PillModel[]): void { pills?.forEach(p => p.active = true);  }
  deselectAll(pills: PillModel[]): void { pills?.forEach(p => p.active = false); }

  toggleList(listValue: 'favouriteOpen' | 'allOpen'): void {
    this[listValue] = !this[listValue];
  }

}
